import { PagePerformedByRequestDTO } from './page-performed-by-request-dto';

export interface ReadUserRolesRequestDTO extends PagePerformedByRequestDTO {
    languageCd?: string;
}
